import React, { memo, useEffect } from 'react'
import { useAppSelector } from '../../hooks/useAppSelector'
import { selectUsers } from '../../store/selectors/userSelectors'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import { buildControlsExt, selectInput } from '../inputs/controls'
import { fetchUsers } from '../../store/async-thunks/users/fetchUsers'

interface Props {
    inputState: any
    setInputState: Function
}

export const LoginFilter = memo(function LoginFilter(props: Props) {
    const { inputState, setInputState } = props
    const dispatch = useAppDispatch()

    const users = useAppSelector(selectUsers)
    const userLogins = users?.reduce((acc, user) => {
        acc.push(user.login)
        return acc
    }, ['All'])

    useEffect(() => {
        dispatch(fetchUsers())
    }, [dispatch])

    const loginSelect = buildControlsExt(
        [
            selectInput({
                name: 'login',
                isLabelHidden: true,
                className: 'mb-2 label-sm flex-1',
                options: userLogins,
                selected: inputState?.login ?? userLogins[0]
            }),
        ],
        inputState,
        setInputState,
    )

    return (
        <div className=" d-flex flex-column gap-1">
            <span>Initiator</span>
            <div className="w-100">
                {loginSelect}
            </div>
        </div>
    )
})